module.exports = __webpack_public_path__ + "img/imgs13.e0344d70.png";